import { ArrowRightIcon } from '@grupoboticario/flora-react-icons';
import { Modal } from 'ui/components/compounds';
import { ButtonSolid } from 'ui/components/primitives';
import { ComboComponents } from './ComboEdit.styles';
import { useRedirectToCombo } from 'ui/hooks/useRedirectToCombo';
import type { ComboEditProps } from './ComboEdit.d';

const ComboEdit = ({ isOpen, toggleComboEdit }: ComboEditProps) => {
  const { redirectToCombo } = useRedirectToCombo();
  if (!isOpen) {
    return null;
  }

  return (
    <Modal
      align="bottom-center"
      footer={
        <ButtonSolid onClick={redirectToCombo} stretch>
          <ComboComponents.ButtonContent>
            Ir para montagem de combo
            <ArrowRightIcon size={12} />
          </ComboComponents.ButtonContent>
        </ButtonSolid>
      }
      header="Você quer editar o combo?"
      onClose={toggleComboEdit}
      size="large"
      sizeButton="small"
      stretch
      variant="confirmation"
      visible={isOpen}
    >
      Para alterar a quantidade ou trocar itens do seu combo, você será direcionado para a tela de
      montagem dos combos.
    </Modal>
  );
};

export default ComboEdit;
